import React,{ useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { cities } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const DestinationsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-32 pb-16 bg-stone-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-6">
            Destinations
          </h1>
          <p className="text-white/70 text-lg max-w-2xl">
            Six of Italy's most popular destinations, covered with a local's perspective. Each guide cuts through the noise to give you exactly what you need.
          </p>
        </div>
      </section>

      {/* Cities Grid */}
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {cities.map((city) => (
              <Link
                key={city.id}
                to={`/city/${city.slug}`}
                className="group"
              >
                <div className="relative aspect-[4/5] rounded-2xl overflow-hidden mb-4">
                  <img
                    src={city.image}
                    alt={city.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                  
                  {/* Content */}
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <p className="text-amber-200 text-sm font-medium mb-2">{city.tagline}</p>
                    <h3 className="text-2xl font-serif text-white mb-2">{city.name}</h3>
                    <p className="text-white/70 text-sm mb-4">{city.description}</p>
                    
                    {/* What's included */}
                    <div className="space-y-2 mb-4">
                      <p className="text-white/50 text-xs uppercase tracking-wide">Free preview includes:</p>
                      <div className="flex flex-wrap gap-2">
                        {city.freeHighlights.map((highlight) => (
                          <span
                            key={highlight}
                            className="px-2 py-1 bg-white/10 backdrop-blur-sm rounded text-xs text-white"
                          >
                            {highlight}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="flex items-center justify-between pt-4 border-t border-white/20">
                      <span className="text-white/60 text-sm">Full guide from</span>
                      <span className="text-white font-medium">{city.guidePrice}</span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-2 text-stone-700 font-medium group-hover:text-amber-700 transition-colors">
                  <span>Explore {city.name}</span>
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Value Prop */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-serif text-stone-900 mb-6">
            Why not just use TripAdvisor?
          </h2>
          <p className="text-stone-600 text-lg leading-relaxed mb-8">
            You could. And you'd spend hours scrolling through thousands of listings, trying to figure out which reviews are real, which restaurants are tourist traps, and which "hidden gems" are actually hidden.
          </p>
          <p className="text-stone-600 text-lg leading-relaxed mb-8">
            Or you could get a curated list from someone who actually lives here. No algorithms. No sponsored content. Just the places I'd send my own friends.
          </p>
          <Link
            to="/#how-it-works"
            className="inline-block px-8 py-4 bg-stone-900 text-white rounded-full font-medium hover:bg-stone-800 transition-colors"
          >
            Learn How It Works
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DestinationsPage;
